import { LitElement, html } from '@hh/global.js'

class CollectionFilters extends LitElement {
  constructor() {
    super()
    this.lastFilterSectionHeight = null
    this.onDocumentScroll = this.onDocumentScroll.bind(this)
    this.onWindowResize = this.onWindowResize.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()
    this.collectionDrawerEl = document.querySelector('collection-filter-drawer')

    this.handleFilterButton()
    this.handleDesktopSortDropdown()
    this.initMobileProductGridColumns()

    document.querySelector('main').classList.add('relative')
    this.closest('section').classList.add('sticky__filters')
    this.closest('section').setAttribute('data-collection-filters-sticky', '')

    document.addEventListener('scroll', this.onDocumentScroll, false)
    window.addEventListener('resize', this.onWindowResize, { passive: true })

    this.initBodyResizeObserver()

    this.setCollectionFilterBottom({ updateAnchorOffset: true })
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    document.removeEventListener('scroll', this.onDocumentScroll, false)
    window.removeEventListener('resize', this.onWindowResize)
    this.bodyResizeObserver?.disconnect()
  }

  onDocumentScroll() {
    this.setCollectionFilterBottom()
  }

  onWindowResize() {
    this.setCollectionFilterBottom({ updateAnchorOffset: true })
  }

  handleFilterButton() {
    const filterButtonsEl = this.querySelectorAll('.js-toggle-filter-button')
    const filterDrawerEl = document.querySelector('collection-filter-drawer')
    const productGridContainer = document.querySelector(
      '[data-collection-product-grid]'
    )

    filterButtonsEl?.forEach((el) => {
      el.addEventListener('click', () => {
        if (!filterDrawerEl || !productGridContainer) return
        el.classList.toggle('is-show')
        filterDrawerEl.toggleAttribute('open')
        productGridContainer.setAttribute('data-animate-switch', '')

        setTimeout(() => {
          productGridContainer.removeAttribute('data-animate-switch')
          productGridContainer.classList.toggle(
            'collection-product-grid__narrow'
          )
        }, 500)
      })
    })
  }

  initMobileProductGridColumns() {
    const productGridContainer = document.querySelector(
      '[data-collection-product-grid]'
    )
    if (!productGridContainer) return

    const toggleRoot = this.querySelector('[data-grid-view-toggle]')
    if (!toggleRoot) return

    const colsSessionKey = 'hh-collection-mobile-grid-cols'
    const customizedSessionKey = 'hh-collection-mobile-grid-customized'

    const applyMobileCols = (cols) => {
      const normalized = cols === '1' || cols === 1 ? '1' : '2'
      productGridContainer.classList.toggle(
        'collection-product-grid__container--mobile-cols-1',
        normalized === '1'
      )

      toggleRoot.classList.remove('active-1', 'active-2')
      toggleRoot.classList.add(normalized === '1' ? 'active-1' : 'active-2')

      toggleRoot.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.checked = input.value === normalized
      })
    }

    const userChoseGridThisSession =
      sessionStorage.getItem(customizedSessionKey) === '1'
    const storedCols = sessionStorage.getItem(colsSessionKey)
    const hasStoredChoice =
      userChoseGridThisSession &&
      (storedCols === '1' || storedCols === '2')

    const cols = hasStoredChoice
      ? storedCols
      : toggleRoot.dataset.defaultValue || '2'

    toggleRoot.addEventListener('change', (e) => {
      const input = e.target
      if (
        input.type !== 'radio' ||
        !toggleRoot.contains(input) ||
        (input.value !== '1' && input.value !== '2')
      ) {
        return
      }
      sessionStorage.setItem(colsSessionKey, input.value)
      sessionStorage.setItem(customizedSessionKey, '1')
      applyMobileCols(input.value)
    })

    applyMobileCols(cols)
  }

  handleDesktopSortDropdown() {
    const sortDropdown = this.querySelector('[data-desktop-sort-dropdown]')
    const mobileSortRadios = document.querySelectorAll(
      '[data-mobile-sort-radio]'
    )
    if (!sortDropdown) return

    sortDropdown.addEventListener('change', (e) => {
      const selectedValue = e.target.value
      mobileSortRadios.forEach((radio) => {
        if (radio.value === selectedValue && !radio.checked) {
          radio.checked = true
          radio.dispatchEvent(new Event('change'))
        }
      })
    })
  }

  initBodyResizeObserver() {
    this.lastElTopAndBottom = { top: 0, bottom: 0 }

    this.bodyResizeObserver = new ResizeObserver(() => {
      const { top: elTop, bottom: elBottom } = this.getBoundingClientRect()
      if (
        elTop === this.lastElTopAndBottom.top &&
        elBottom === this.lastElTopAndBottom.bottom
      ) {
        return
      }

      this.lastElTopAndBottom.top = elTop
      this.lastElTopAndBottom.bottom = elBottom

      this.setCollectionFilterBottom({ updateAnchorOffset: true })
    })

    this.bodyResizeObserver.observe(document.body)
  }

  setCollectionFilterBottom({ updateAnchorOffset = false } = {}) {
    const { bottom: elBottom } = this.getBoundingClientRect()

    this.collectionDrawerEl.style.setProperty(
      '--hh-collection-filter-bottom',
      `${elBottom}px`
    )

    if (updateAnchorOffset) {
      const filterSection = this.closest('section')
      if (!filterSection) {
        return
      }
      const h = filterSection.offsetHeight
      const nextHeight = Number.isFinite(h) && h > 0 ? h : 0
      if (nextHeight === this.lastFilterSectionHeight) {
        return
      }
      this.lastFilterSectionHeight = nextHeight
      document.documentElement.style.setProperty(
        '--hh-plp-anchor-below-filters',
        `${nextHeight}px`,
      )
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('collection-filters', CollectionFilters)
